import { render } from "./CreditSection.vue?vue&type=template&id=a1ff698a&scoped=true"
import script from "./CreditSection.vue?vue&type=script&lang=js"
export * from "./CreditSection.vue?vue&type=script&lang=js"

import "./CreditSection.vue?vue&type=style&index=0&id=a1ff698a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ff698a"]])

export default __exports__